module.exports = __webpack_public_path__ + "assets/instagram.36d0ccd5.svg";